(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  // CSS-only sizing for this carousel (via calc()/cqw custom properties)
  // kept producing oversized, inconsistent card widths in practice -- the
  // shared component's width chain doesn't resolve cleanly for this layout.
  // Measuring and setting pixel widths directly in JS sidesteps that: it
  // can't be "roughly right", it's exactly (track width - gaps) / columns.
  function sizeProductCarousel(root) {
    const columns = Number(root.dataset.carouselColumns);
    if (!columns) return;

    const gap = Number(root.dataset.carouselGap) || 0;
    const track = root.querySelector('slideshow-slides');
    const slides = root.querySelectorAll('.resource-list__slide');
    if (!track || !slides.length) return;

    const cardWidth = (track.clientWidth - gap * (columns - 1)) / columns;
    if (!(cardWidth > 0)) return;

    slides.forEach((slide) => {
      slide.style.setProperty('width', `${cardWidth}px`, 'important');
      slide.style.setProperty('max-width', `${cardWidth}px`, 'important');
      slide.style.setProperty('flex', `0 0 ${cardWidth}px`, 'important');
    });
  }

  document.querySelectorAll('[data-testid="product-list"][data-carousel-columns]').forEach((root) => {
    sizeProductCarousel(root);

    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => sizeProductCarousel(root), 100);
    });
  });

  // No-ops on any section where the carousel nav wasn't rendered (i.e.
  // layout_type != 'carousel'), since the querySelectorAll below simply
  // finds nothing there.
  document.querySelectorAll('[data-carousel-nav]').forEach((nav) => {
    const section = nav.closest('[data-testid="product-list"]');
    const track = section?.querySelector('slideshow-slides');
    if (!track) return;

    // Independent of the shared slideshow component's one-slide-at-a-time
    // next()/previous(): scrolls by the track's own visible width, which
    // (with --peek-next-slide-size zeroed out above) equals exactly one
    // full page of `columns` cards -- so it pages in whole groups.
    nav.querySelector('[data-carousel-prev]')?.addEventListener('click', () => {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    nav.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
